import { render, staticRenderFns } from "./QuotesModalTranscription.vue?vue&type=template&id=98decaca&scoped=true"
import script from "./QuotesModalTranscription.vue?vue&type=script&lang=js"
export * from "./QuotesModalTranscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98decaca",
  null
  
)

export default component.exports